<template>
  <AppModal
    v-if="currentId"
    :mode="mode"
    @close="$emit('cancelDelete')"
    width="max-w-md"
  >
    <template #body>
      <div class="flex flex-col items-center justify-center gap-3 text-center">
        <span
          class="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-danger-100 bg-opacity-15 text-danger-100"
        >
          <TriangleAlert :size="30" :stroke-width="1.75" />
        </span>
        <h5 class="text-[18px] font-semibold leading-none">
          Are you Sure you Want to Delete this?
        </h5>
        <p
          class="text-[14px] font-medium"
          :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
        >
          This action is <span class="font-semibold">permanent</span> and
          <span class="font-semibold">very hard to undo</span>. Please confirm
          if you want to proceed.
        </p>
        <div class="flex items-center gap-2">
          <AppButton
            title="Delete"
            @action="deleteRecord(currentId)"
            type="danger"
          />
          <AppButton
            title="Cancel"
            @action="$emit('cancelDelete')"
            type="secondary"
          />
        </div>
      </div>
    </template>
  </AppModal>
</template>

<script>
import { TriangleAlert } from "lucide-vue-next";
import ApiRequest from "@L/ApiRequest";
import { useGlobalErrorHandler } from "@L/errorHandler";
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import AppModal from "@C/Common/AppModal.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "DeleteItem",
  props: {
    currentId: [String, Number],
    deleteType: {
      type: String,
      default: "contact",
    },
    isSimpleRemove: {
      type: Boolean,
      default: false,
    },
    mode: String,
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      handleError,
    };
  },
  components: {
    TriangleAlert,
    AppModal,
    AppButton,
  },
  methods: {
    async deleteRecord(id) {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().delete(`/${this.deleteType}/${id}`);
        if (data) {
          if (this.isSimpleRemove) {
            this.$emit("recordDeletedWithArrayRemove");
          } else {
            this.$emit("recordDeleted");
          }
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
  },
};
</script>
